<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import * as _ from 'lodash';
import featureFlag from '@/api/featureFlag';

export default {
  name: 'OpenBankingMixin',
  computed: {
    ...mapState('session', ['isRestrictedCustomer']),
    ...mapState('credentials', ['obkSourceConfigurations']),
  },
  methods: {
    ...mapActions('modalRootStore', ['closeAllModals']),
    ...mapMutations('onboardingState', ['setError']),
    async isOpenBankingSupported({ sourceId }) {
      const sourceName = this.getSourceName(sourceId);
      // keeping yahav till we open
      if (sourceName === 'yahav') {
        return (await featureFlag.getTreatment(`${sourceId}_open_banking`)) === 'on';
      }
      return this.isRestrictedCustomer || _.some(this.obkSourceConfigurations,
        {
          bankIdentifier: sourceName,
          enabled: true,
          type: 'enableConsentCreation',
        });
    },
    getSourceName(sourceId) {
      if (sourceId === 'amex') {
        return 'americanexpress';
      }
      return sourceId;
    },
  },
};
</script>
